import type { ScheduleDto } from '@octopus-do/octopus-api-client'
import { DropdownMenu } from '@octopus-do/octopus-storybook'
import type React from 'react'

import { SettingsMenuButton, SettingsMenuContent } from './components'
import { useSettings } from './useSettings'

interface Props {
  onRecrawl: () => void
  onScheduled: () => void
  schedule: ScheduleDto | null
}

export const SettingsMenu: React.FC<Props> = ({
  onRecrawl,
  onScheduled,
  schedule,
}) => {
  const { onClick } = useSettings({ onRecrawl, onScheduled, schedule })

  return (
    <DropdownMenu.Root content={SettingsMenuContent} onClick={onClick}>
      <SettingsMenuButton />
    </DropdownMenu.Root>
  )
}
